export default {
  meta: {
    title: '资源审核-新增/编辑'
  }
};
